import { render, staticRenderFns } from "./AssessmentResult.vue?vue&type=template&id=083a7c8c"
import script from "./AssessmentResult.vue?vue&type=script&lang=js"
export * from "./AssessmentResult.vue?vue&type=script&lang=js"
import style0 from "./AssessmentResult.vue?vue&type=style&index=0&id=083a7c8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports